<template>
  <div class="questions-layout">
    <avatar class="avatar" :imgSrc="serverAvatar" />
    <div>
      <div class="questions-wrapper" v-if="questionTypes.length > 0">
        <div
          v-for="item in questionTypes"
          :key="item.id"
          class="question-item"
          v-show="item.display == 1 && item.uid != 0"
          @click="selectQuestion('service', item.id, item)"
        >
          {{ item.name }}
        </div>
        <!-- <div
          class="question-item full-width help"
          @click="selectQuestion('help', 'helpId')"
        >
          游客请查看《帮助中心》
        </div> -->
        <div
          v-for="item in questionTypes"
          :key="`person-${item.uid}`"
          v-show="
            customerInfo &&
              customerInfo.isShowGame &&
              item.display == 1 &&
              item.uid == 0
          "
          class="question-item full-width person"
          @click="selectQuestion('personService', 'personId')"
        >
          <img src="../../../../assets/imgs/person.svg" alt />
          {{ item.name }}
        </div>
      </div>

      <div class="questions-wrapper" v-if="questionTypes.length > 0">
        <div
          v-for="item in scenesList"
          :key="item.scenesId"
          class="question-item download"
          @click="selectQuestion('special', item.scenesId, item)"
        >
          {{ item.name }}

          <span class="new-message" v-if="item.hasNewMessage"></span>
        </div>
        <div
          v-if="hasDownloadPage"
          class="question-item full-width download"
          @click="selectDownload"
        >
          <img :src="downloadInfo.style.leftIcon" alt />
          {{ downloadInfo.title }}
        </div>
      </div>

      <div v-if="questionTypes.length <= 0" class="skillscatch">
        网络请求失败请<a @click="reload" href="javascript:void(0)">刷新</a>重试
      </div>
    </div>
  </div>
</template>

<script>
//询前页问题组件
import constant from "src/constant";
import { MessageBox } from "element-ui";
import store from "@/app/customer/store";

export default {
  name: "questions-type",
  data() {
    return {
      activeQuestionId: "", //选中的技能组id
      hasDownloadPage: false,
      downloadInfo: {},
      hasScenes: false,
      scenesList: []
    };
  },
  computed: {
    ...mapState([
      "blackFlag",
      "questionTypes",
      "customerInfo",
      "serverAvatar",
      "mainColor",
      "userName",
      "isSeoView"
    ])
    // ...mapState({
    //   blackFlag: state => state.blackFlag,
    //   questionTypes: state => state.questionTypes,
    //   customerInfo: state => state.customerInfo,
    //   serverAvatar: state => state.serverAvatar
    // })
  },
  async mounted() {
    const { data } = await this.$store
      .dispatch("queryDownloadPages")
      .then(res => res);
    if (data) {
      this.hasDownloadPage = true;
      this.downloadInfo = data;
    }

    const res = await this.$store
      .dispatch("queryScenes", { username: this.userName })
      .then(res => res);

    if (
      this.isSeoView === "true" ||
      (this.isSeoView === true && res.data.length > 0)
    ) {
      this.hasScenes = true;
      this.scenesList = res.data;
    }
  },
  methods: {
    ...mapActions({
      initChannel: "initChannel"
    }),
    reload() {
      this.$store.dispatch("queryCusSkill");
    },
    handlePerson() {
      //人工客服
      this.$store.commit("setState", {
        isUploadImg: false,
        isBeforeConnect: false,
        isPerson: true,
        chatType: 0
      });
      // this.$store.commit("chat/setState", {
      //   messageMap: []
      // }); //清空消息
      this.$store.commit("clearAllMessages");
      // this.$router.push({ path: "/conversation" });
      this.initChannel({ orderImgUrls: "", router: this.$router });
    },
    handleHelp() {
      //帮助中心
      let url = constant.ML_URL.pcHelpCenter;
      window.open(url);
    },
    handleSpecial(item) {
      const chatType = item.scenesId || item;
      this.$store.commit("setState", {
        questionText: item.name,
        skillType: item.skillType,
        chatType,
        isBeforeConnect: false,
        isSpecialScenes: true
      });
      this.$router.push({ path: "uploadImg" });
    },
    HandleService(item) {
      const chatType = item.uid || item;
      this.$store.commit("setState", {
        questionText: item.name,
        skillType: item.skillType,
        chatType,
        isBeforeConnect: false
      });
      this.$router.push({ path: "uploadImg" });
      //点击技能组
      // const chatType = item.uid;
      // const content = `${`您咨询【<font class="yellow-text">${item.name}</font>】问题，`}为方便客服更快定位问题，请上传相关截图。`;
      // this.$store.commit("setState", {
      //   isShowEvaluatePage: false,
      //   chatType,
      //   questionText: item.name,
      //   isUploadImg: true
      // });
      // this.$store.dispatch(
      //   "chat/addSysMessage",
      //   { content, type: constant.MESSAGE_TYPE.MT_QU },
      //   { root: true }
      // );
    },
    handleTourst() {
      //游客模式
      MessageBox.confirm("请先登录或咨询游客问题", "提示", {
        customClass: `tourist-before-login ${this.mainColor}`,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonClass: "confirmBtn",
        cancelButtonClass: "cancelBtn",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // window.location.href = constant.ML_URL.pc;
        })
        .catch(() => {});
    },
    selectDownload() {
      let url = this.downloadInfo.downloadPage;
      window.open(url);
    },
    selectQuestion(type, questionId, item = "") {
      this.$store.commit("setState", {
        isSpecialScenes: false
      });
      const selectMapFun = {
        personService: this.handlePerson,
        help: this.handleHelp,
        service: this.HandleService,
        tourst: this.handleTourst,
        default: this.HandleService,
        special: this.handleSpecial
      };
      let activeFun;
      if (
        type === "service" &&
        this.customerInfo.type === constant.TOURIST_TYPE
      ) {
        activeFun = selectMapFun["tourst"];
      } else if (type === "special") {
        this.customerInfo.type === constant.TOURIST_TYPE;
        item["uid"] = item.scenesId;
        activeFun = selectMapFun[type];

        store.commit("setState", {
          enterScene: item.scenesId
        });
      } else {
        activeFun = selectMapFun[type] || selectMapFun["default"];
      }

      if (this.blackFlag != 0) {
        return; //被拉黑 点击无效
      }

      const questionsIds = this.questionTypes.map(s => s.id); //拿到技能组id集合
      if (
        questionId === this.activeQuestionId &&
        questionsIds.includes(this.activeQuestionId)
      ) {
        activeFun(item);
        return; //如果选择的技能组与上一次相同则不生效  需要排除掉帮助中心和人工客服!
      }
      this.activeQuestionId = questionId; //改变选中状态

      activeFun(item);
    }
  }
};
</script>

<style scoped lang="less">
.skillscatch {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  line-height: 1.5;
  text-align: center;
  color: #d3dce6;
}

.questions-layout {
  margin-top: 40px;
  height: auto;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;

  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .questions-wrapper {
    display: flex;
    text-align: center;
    flex-wrap: wrap;

    .question-item {
      background-color: #ffff;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 2px;

      &.full-width {
        flex-basis: 100%;
        margin: 0;
      }
    }

    .btn {
      background-color: var(--primary-color);
      color: #fff;
    }

    .active {
      background: red;
    }
  }
}

.pc {
  .questions-wrapper {
    width: 551px;
    padding: 8px 8px 8px 8px;
    justify-content: space-between;
    background: #fff;
    border-radius: 10px;
    font-size: 14px;
    color: #1e1e1e;

    .question-item {
      width: calc((100% - (16px)) / 3);
      height: 35px;
      margin-bottom: 8px;
      border-radius: 4px;
      line-height: 35px;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.05);
      transition-duration: 0.3s;
      color: var(--pre-button-text-color);
      background: var(--pre-button-bg);
      cursor: pointer;
      transition: all 0.2s;

      &:active,
      &:hover {
        background: var(--pre-button-click);
      }

      &:active {
        color: var(--pre-button-click-color);
      }

      &:hover {
        color: #fff;
      }
    }

    .help {
      color: var(--pre-button-help-text);
    }

    .person {
      margin-top: 8px !important;
      color: var(--pre-button-person-text);
      display: flex;
      justify-content: center;

      img {
        margin-right: 8px;
        width: 20px;
      }
    }

    .download {
      margin-top: 8px !important;
      color: var(--pre-button-person-text);
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin-right: 8px;
        height: 25px;
      }
    }

    .new-message {
      width: 6px;
      height: 6px;
      background-color: red;
      border-radius: 100%;
      margin-left: 4px;
    }
  }
}
</style>

<style lang="less">
.flex-column {
  display: flex;
  flex-direction: column;
}

.tourist-before-login {
  max-width: 320px;
  position: absolute;
  top: 33%;
  left: 50%;
  transform: translateX(-50%);

  .cancelBtn {
    &:hover,
    &:active,
    &:focus {
      color: var(--button-bg);
      border-color: var(--button-bg);
      background: #fff;
    }
  }

  .confirmBtn {
    background-color: var(--button-bg);
    border: 1px solid var(--header-bg);

    &:hover {
      opacity: 0.8;
    }

    &:active {
      background: var(--button-click) !important;
      color: var(--button-text-click) !important;
    }
  }
}

.tourist-before-login .el-message-box__message p {
  white-space: nowrap;
}

.finishChannel {
  max-width: 350px;
}
</style>
